(() => {
  const sticky = document.querySelector('[data-seep-sticky-atc]');
  const mainSubmit = document.querySelector('.product-form__submit');
  if (sticky && mainSubmit) {
    const stickyButton = sticky.querySelector('button');
    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0 });
    observer.observe(mainSubmit);
    stickyButton?.addEventListener('click', () => mainSubmit.click());
  }

  document.querySelectorAll('[data-seep-scroll]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
